"use client";

import type { Content } from "@tiptap/react";
import type { ComponentProps } from "react";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import type { ToolbarItem } from "@/ui/admin/tiptap-bubble-menu";
import { TiptapEditor } from "@/ui/admin/tiptap-editor";
import { debounce } from "@/ui/hooks/use-debounced-value";

export const RichtTextEditor = ({
	content,
	toolbarOverrides,
	onChange,
	fieldPath,
}: {
	content: Content;
	name?: string;
	className?: string;
	toolbarOverrides?: ToolbarItem[];
	onChange?: ComponentProps<typeof TiptapEditor>["onChange"];
	fieldPath?: string;
}) => {
	const { saveSelectedPageSectionField: saveSelectedComponentField } = useStoreBuilderContext();

	return (
		<TiptapEditor
			content={content}
			toolbarOverrides={toolbarOverrides}
			onChange={
				onChange ||
				debounce(
					async (content) => {
						await saveSelectedComponentField({ fieldPath: fieldPath ?? "content", value: content });
					},
					500,
					{ trailing: true },
				)
			}
		/>
	);
};
